import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_ScanFailedCard = _resolveComponent("ScanFailedCard")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DataWrapper, {
        label: "No. STT/No. Bagging",
        class: "col-span-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LpInput, {
            ref: "inputStt",
            isErrorIconInput: false,
            isErrorIconCaption: "",
            sizeInput: "24px",
            labelStacked: "Contoh : No. STT/No. Bagging : 99LP1234567890123/88-22-12345678",
            placeholder: "Masukan No. STT/No. Bagging atau Scan Barcode",
            onEnter: _ctx.addSttNumber,
            modelValue: _ctx.scanNumber,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.scanNumber = $event)),
            bold: !!_ctx.scanNumber,
            errorCaption: _ctx.errorSttNumber,
            error: _ctx.errorSttNumber !== ''
          }, null, 8, ["onEnter", "modelValue", "bold", "errorCaption", "error"])
        ]),
        _: 1
      }),
      _createVNode(_component_ScanFailedCard, { data: _ctx.scanFailedList }, null, 8, ["data"])
    ]),
    _createVNode(_component_LpButton, {
      onClick: _ctx.addSttNumber,
      customClass: "px-12 py-2.5",
      fontWeight: "semibold",
      title: "Tambah",
      textColor: "white",
      disabled: _ctx.isDisableAddSttNumber
    }, null, 8, ["onClick", "disabled"]),
    _hoisted_2,
    _createVNode(_component_Notification, {
      data: _ctx.detailSttNotification,
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.notification = $event)),
      status: _ctx.isErrorNotification ? 'error' : 'success',
      onClose: _ctx.onCloseNotification,
      messageError: _ctx.messageErrorNotification,
      titleMessageError: _ctx.titleMessageError
    }, null, 8, ["data", "modelValue", "status", "onClose", "messageError", "titleMessageError"])
  ], 64))
}